// frontend/src/components/common/Notification.jsx
import React, { useEffect } from "react";
import "./Modal.css"; // Using the same CSS file for notification styles

const Notification = ({ message, type, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={`notification ${type}`}>
      <span>{message}</span>
      <button onClick={onClose} className="notification-close">
        &times;
      </button>
    </div>
  );
};

export default Notification;
